import RESTClient from 'web-app/api/clients/rest-client-famly-app';

export const fetchMealTypes = (institutionId, childId = null) => {
    if (childId) {
        return RESTClient.getAuthenticatedObservable(`v2/mealPlan/mealTypes/${institutionId}`, {childId});
    }
    return RESTClient.getAuthenticatedObservable(`v2/mealPlan/mealTypes/${institutionId}`);
};

export const updateMealTypes = (institutionId, mealTypes) => {
    return RESTClient.putAuthenticatedObservable(`v2/mealPlan/mealTypes/${institutionId}`, {mealTypes});
};
